// Writes your routes here

// Configuaration (TEST)
// Service Type Api
export const serviceTypeApi = 'configuration/service-type/list'
export const serviceTypeStoreApi = 'configuration/service-type/store'
export const serviceTypeUpdateApi = 'configuration/service-type/update'
export const serviceTypeToggleStatusApi = 'configuration/service-type/toggle-status'

// Service Process Step
const serviceProcessStepBase = 'configuration/service-process-step'
export const serviceProcessStepListApi = serviceProcessStepBase + '/list'
export const serviceProcessStepStoreApi = serviceProcessStepBase + '/store'
export const serviceProcessStepUpdateApi = serviceProcessStepBase + '/update'
export const serviceProcessStepToggleStatusApi = serviceProcessStepBase + '/toggle-status'

// Service Process Avail
const serviceProcessAvailBase = 'configuration/service-process-avail'
export const serviceProcessAvailListApi = serviceProcessAvailBase + '/list'
export const serviceProcessAvailShowApi = serviceProcessAvailBase + '/show'
export const serviceProcessAvailStoreApi = serviceProcessAvailBase + '/store'
export const serviceProcessAvailUpdateApi = serviceProcessAvailBase + '/update'

// Patient Category Api
export const patientCategoryApi = 'configuration/patient-category/list'
export const patientCategoryStoreApi = 'configuration/patient-category/store'
export const patientCategoryUpdateApi = 'configuration/patient-category/update'
export const patientCategoryToggleStatusApi = 'configuration/patient-category/toggle-status'

// Event Info Setup Api
export const eventInfoSetupApi = 'configuration/event-info-setup/list'
export const eventInfoStoreApi = 'configuration/event-info-setup/store'
export const eventInfoUpdateApi = 'configuration/event-info-setup/update'
export const eventInfoToggleStatuseApi = 'configuration/event-info-setup/toggle-status'

// Event Info Setup Api
export const stallSetupApi = 'configuration/stall-setup/list'
export const stallStoreApi = 'configuration/stall-setup/store'
export const stallUpdateApi = 'configuration/stall-setup/update'
export const stallToggleStatuseApi = 'configuration/stall-setup/toggle-status'

// Event Type Setup Routes
export const EventTypeApi = 'configuration/event-type/list'
export const EventTypeStoreApi = 'configuration/event-type/store'
export const EventTypeUpdateApi = 'configuration/event-type/update'
export const EventTypeToggleStatusApi = 'configuration/event-type/toggle-status'

// Fair Stall Fee Setup Routes
export const FairStallApi = 'configuration/fair-stall/list'
export const FairStallStoreApi = 'configuration/fair-stall/store'
export const FairStallUpdateApi = 'configuration/fair-stall/update'
export const FairStallToggleStatusApi = 'configuration/fair-stall/toggle-status'

// Faq list Routes
export const faqListApi = 'configuration/faq-setup/index'
export const faqStoreApi = 'configuration/faq-setup/store'
export const faqUpdateApi = 'configuration/faq-setup/update'
export const faqDeleteApi = 'configuration/faq-setup/destroy'
export const faqToggleStatus = 'configuration/faq-setup/toggle-status'

// Supplier Type Setup Routes
export const supplierListApi = 'configuration/supplier-setup/index'
export const supplierStoreApi = 'configuration/supplier-setup/store'
export const supplierUpdateApi = 'configuration/supplier-setup/update'
export const supplierDeleteApi = 'configuration/supplier-setup/destroy'
export const supplierToggleStatus = 'configuration/supplier-setup/toggle-status'

// eligibility-category
export const eligibilityCatListApi = 'configuration/eligibility-category/list'
export const eligibilityCatStoreApi = 'configuration/eligibility-category/store'
export const eligibilityCatUpdateApi = 'configuration/eligibility-category/update'
export const eligibilityCatToggleStatusApi = 'configuration/eligibility-category/toggle-status'
// Fair Evaluation Setup Api

export const fairEvaluationListApi = 'configuration/fair-evaluation-setup/list'
export const fairEvaluationStoreApi = 'configuration/fair-evaluation-setup/store'
export const fairEvaluationUpdateApi = 'configuration/fair-evaluation-setup/update'
export const fairEvaluationToggleStatusApi = 'configuration/fair-evaluation-setup/toggle-status'
export const fairEvaluationShowApi = 'configuration/fair-evaluation-setup/show'

// Stall Type Api
export const stallTypeApi = 'configuration/stall-type/list'
export const stallTypeStoreApi = 'configuration/stall-type/store'
export const stallTypeUpdateApi = 'configuration/stall-type/update'
export const stallTypeToggleStatusApi = 'configuration/stall-type/toggle-status'

// Questionnaire Type
export const QuestionnaireType = 'config/questionnaire-type'
export const questionnaireTypeListApi = QuestionnaireType + '/list'
export const questionnaireTypeStoreApi = QuestionnaireType + '/store'
export const questionnaireTypeUpdate = QuestionnaireType + '/update'
export const questionnaireTypeStatus = QuestionnaireType + '/toggle-status'

// guest-house
export const guestHouseListApi = 'config/guest-house/list'
export const guestHouseStoreApi = 'config/guest-house/store'
export const guestHouseUpdateApi = 'config/guest-house/update'
export const guestHouseToggleStatusApi = 'config/guest-house/toggle-status'

// Accommodation Type
export const accommodationType = 'config/accommodation-type'
export const accommodationTypeListApi = accommodationType + '/list'
export const accommodationTypeStoreApi = accommodationType + '/store'
export const accommodationTypeUpdate = accommodationType + '/update'
export const accommodationTypeStatus = accommodationType + '/toggle-status'

// Organization Type Api
export const OrganizationType = 'config/organization-type'
export const organizationTypeListApi = OrganizationType + '/list'
export const organizationTypeStoreApi = OrganizationType + '/store'
export const organizationTypeUpdate = OrganizationType + '/update'
export const organizationTypeStatus = OrganizationType + '/toggle-status'

// grade Api
export const grade = 'config/grade'
export const gradeListApi = grade + '/list'
export const gradeStoreApi = grade + '/store'
export const gradeUpdateApi = grade + '/update'
export const gradeStatusApi = grade + '/toggle-status'
// designation Api
export const designation = 'config/designation'
export const designationListApi = designation + '/list'
export const designationStoreApi = designation + '/store'
export const designationUpdateApi = designation + '/update'
export const designationStatusApi = designation + '/toggle-status'

// committee-designation Api
export const committeeDesignation = 'config/committee-designation'
export const committeeDesignationListApi = committeeDesignation + '/list'
export const committeeDesignationStoreApi = committeeDesignation + '/store'
export const committeeDesignationUpdateApi = committeeDesignation + '/update'
export const committeeDesignationStatusApi = committeeDesignation + '/toggle-status'

// batch Api
export const batch = 'config/batch'
export const batchListApi = batch + '/list'
export const batchStoreApi = batch + '/store'
export const batchUpdateApi = batch + '/update'
export const batchStatusApi = batch + '/toggle-status'

// Training Name Api
export const TrainingName = 'config/training-name'
export const trainingNameListApi = TrainingName + '/list'
export const trainingNameStoreApi = TrainingName + '/store'
export const trainingNameUpdate = TrainingName + '/update'
export const trainingNameStatus = TrainingName + '/toggle-status'

// FAQ Setup
export const faqSetupListApi = 'config/faq-setup/list'
export const faqSetupListStoreApi = 'config/faq-setup/store'
export const faqSetupListUpdateApi = 'config/faq-setup/update'
export const faqSetupListToggleStatusApi = 'config/faq-setup/toggle-status'

// Accommodation Setup
export const accommodationSetupListApi = 'config/accommodation-setup/list'
export const accommodationSetupListStoreApi = 'config/accommodation-setup/store'
export const accommodationSetupListUpdateApi = 'config/accommodation-setup/update'
export const accommodationSetupListToggleStatusApi = 'config/accommodation-setup/toggle-status'

// Document Type Api
export const DocumentType = 'config/document-type'
export const documentTypeListApi = DocumentType + '/list'
export const documentTypeStoreApi = DocumentType + '/store'
export const documentTypeUpdate = DocumentType + '/update'
export const documentTypeStatus = DocumentType + '/toggle-status'

// Registration Api
export const RegistrationFor = 'config/registration-for'
export const registrationForListApi = RegistrationFor + '/list'
export const registrationForStoreApi = RegistrationFor + '/store'
export const registrationForUpdate = RegistrationFor + '/update'
export const registrationForStatus = RegistrationFor + '/toggle-status'

// Questionnaire Setup
export const Questionnairesetup = 'config/questionnaire-setup'
export const questionnaireSetupListApi = Questionnairesetup + '/list'
export const questionnaireSetupStoreApi = Questionnairesetup + '/store'
export const questionnaireSetupUpdate = Questionnairesetup + '/update'
export const questionnaireSetupStatus = Questionnairesetup + '/toggle-status'

// Report Heading
export const ReportHeading = 'config/report-heading'
export const reportHeadingList = ReportHeading + '/list'
export const reportHeadingStore = ReportHeading + '/store'
export const reportHeadingUpdate = ReportHeading + '/update'
export const reportToggleStatus = ReportHeading + '/toggle-status'

// Education Qualification
export const EduQualification = 'config/edu-qualification'
export const eduQualificationList = EduQualification + '/list'
export const eduQualificationStore = EduQualification + '/store'
export const eduQualificationUpdate = EduQualification + '/update'
export const eduQualificationToggleStatus = EduQualification + '/toggle-status'

// Module name
export const moduleNameListApi = 'config/module-name/list'
export const moduleNameStoreApi = 'config/module-name/store'
export const moduleNameUpdateApi = 'config/module-name/update'
export const moduleNameToggleStatusApi = 'config/module-name/toggle-status'

// Venue
export const venue = 'config/venue'
export const venueInfoList = venue + '/list'
export const venueInfoStore = venue + '/store'
export const venueInfoUpdate = venue + '/update'
export const venueInfoStatus = venue + '/toggle-status'

// committee name
export const committeeListApi = 'config/committee-name/list'
export const committeeStoreApi = 'config/committee-name/store'
export const committeeToggleApi = 'config/committee-name/toggle-status'
export const committeeUpdateApi = 'config/committee-name/update'

// food-package
export const foodPackageListApi = 'config/food-package/list'
export const foodPackageStoreApi = 'config/food-package/store'
export const foodPackageToggleStatusApi = 'config/food-package/toggle-status'
export const foodPackageUpdateApi = 'config/food-package/update'

// room-type
export const roomTypeListApi = 'config/room-type/list'
export const roomTypeStoreApi = 'config/room-type/store'
export const roomTypeToggleStatusApi = 'config/room-type/toggle-status'
export const roomTypeUpdateApi = 'config/room-type/update'

// trainer evaluation subject
export const evaluationSubjectListApi = 'config/trainer-evaluation-subject/list'
export const evaluationSubjectStoreApi = 'config/trainer-evaluation-subject/store'
export const evaluationSubjectUpdateApi = 'config/trainer-evaluation-subject/update'
export const evaluationSubjectToggleStatusApi = 'config/trainer-evaluation-subject/toggle-status'
